import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProjectsList from "@/pages/ProjectsList";
import Editor from "@/pages/Editor";
import UploadContribute from "@/pages/UploadContribute";
import ContributeGuide from "@/pages/ContributeGuide";
import AdminGate from "@/components/AdminGate";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* TOP は投稿フォームへ自動リダイレクト（保護者は upload のみアクセス可） */}
          <Route path="/" element={<Navigate to="/upload" replace />} />
          <Route path="/projects" element={<AdminGate><ProjectsList /></AdminGate>} />
          <Route path="/editor/:projectId" element={<AdminGate><Editor /></AdminGate>} />
          <Route path="/editor" element={<Navigate to="/projects" replace />} />
          <Route path="/upload" element={<UploadContribute />} />
          <Route path="/guide" element={<ContributeGuide />} />
          {/* 不明なパスは投稿フォームへ */}
          <Route path="*" element={<Navigate to="/upload" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
